import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import AdminLayout from './components/Layout/AdminLayout';
import AdminLogin from './pages/Auth/AdminLogin';
import SiteFavicon from './components/SiteFavicon';
import Dashboard from './pages/Dashboard';
import TrendingEvents from './pages/TrendingEvents';
import Users from './pages/Users';
import AdminUsers from './pages/AdminUsers';
import RoleBuilder from './pages/RoleBuilder';
import ActivityLogs from './pages/ActivityLogs';
import WaplifyLogs from './pages/WaplifyLogs';
import Content from './pages/Content';
import BlogEditor from './pages/BlogEditor';
import SiteLabels from './pages/SiteLabels';
import Campsites from './pages/Campsites';
import EventTypes from './pages/EventTypes';
import Locations from './pages/Locations';
import Treks from './pages/Treks';
import WhatsAppAutomation from './pages/WhatsAppAutomation';
import Attractions from './pages/Attractions';
import AttractionForm from './pages/AttractionForm';
import TrekPackageForm from './pages/TrekPackageForm';
import TrekScheduleForm from './pages/TrekScheduleForm';
import TrekAttractionForm from './pages/TrekAttractionForm';
import TrekFeeIncludeForm from './pages/TrekFeeIncludeForm';
import TrekInstructionForm from './pages/TrekInstructionForm';
import EventBatches from './pages/EventBatches';
import EventBatchForm from './pages/EventBatchForm';
import SpecialEvents from './pages/SpecialEvents';
import SpecialEventForm from './pages/SpecialEventForm';
import ContactManagement from './pages/ContactManagement';
import OfficeForm from './pages/OfficeForm';
import AboutManagement from './pages/AboutManagement';
import TeamManagement from './pages/TeamManagement';
import CareersManagement from './pages/CareersManagement';
import Applicants from './pages/Applicants';
import CallbackRequests from './pages/CallbackRequests';
import PdfRequests from './pages/PdfRequests';
import VolunteerInquiries from './pages/VolunteerInquiries';
import LeadRequests from './pages/LeadRequests';
import LeadReports from './pages/LeadReports';
import CustomReports from './pages/CustomReports';
import SupportTickets from './pages/SupportTickets';
import CreateManualLead from './pages/CreateManualLead';
import Registrations from './pages/Registrations';
import Tickets from './pages/Tickets';
import Receipts from './pages/Receipts';
import ManualReceipts from './pages/ManualReceipts';
import ManualReceiptForm from './pages/ManualReceiptForm';
import Cancellations from './pages/Cancellations';
import RefundCalculatorCategories from './pages/RefundCalculatorCategories';
import AddOns from './pages/AddOns';
import AddOnForm from './pages/AddOnForm';
import HomeCategories from './pages/HomeCategories';
import HomeCategoryOrder from './pages/HomeCategoryOrder';
import StoreProducts from './pages/StoreProducts';
import StoreProductForm from './pages/StoreProductForm';
import StoreStock from './pages/StoreStock';
import StoreReturns from './pages/StoreReturns';
import StoreMerchandiseOrders from './pages/StoreMerchandiseOrders';
import StoreCamperOrders from './pages/StoreCamperOrders';
import HighlightedEvents from './pages/HighlightedEvents';
import ExpeditionList from './pages/ExpeditionList';
import ExpeditionPage from './pages/ExpeditionPage';
import ShortLinks from './pages/ShortLinks';
import TrainingCamp from './pages/TrainingCamp';
import AdminProfile from './pages/AdminProfile';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import PermissionGuard from './components/PermissionGuard';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <SiteFavicon />
        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminProtectedRoute>
                  <AdminLayout />
                </AdminProtectedRoute>
              </ProtectedRoute>
            }
          >
            <Route index element={<PermissionGuard permission="dashboard"><Dashboard /></PermissionGuard>} />
            <Route
              path="custom-reports"
              element={
                <PermissionGuard permission="reports">
                  <CustomReports />
                </PermissionGuard>
              }
            />
            <Route
              path="trending-events"
              element={
                <PermissionGuard permission="dashboard">
                  <TrendingEvents />
                </PermissionGuard>
              }
            />
            <Route path="users" element={<PermissionGuard permission="users"><Users /></PermissionGuard>} />
            <Route path="admin-users" element={<PermissionGuard permission="users"><AdminUsers /></PermissionGuard>} />
            <Route path="role-builder" element={<PermissionGuard permission="users"><RoleBuilder /></PermissionGuard>} />
            <Route path="activity-logs" element={<PermissionGuard permission="activity_logs"><ActivityLogs /></PermissionGuard>} />
            <Route path="waplify-logs" element={<PermissionGuard permission="super_admin_only"><WaplifyLogs /></PermissionGuard>} />
            <Route path="content" element={<PermissionGuard permission="content"><Content /></PermissionGuard>} />
            <Route path="blogs/new" element={<PermissionGuard permission="content"><BlogEditor /></PermissionGuard>} />
            <Route path="blogs/edit/:id" element={<PermissionGuard permission="content"><BlogEditor /></PermissionGuard>} />
            <Route path="blogs/:id" element={<PermissionGuard permission="content"><BlogEditor /></PermissionGuard>} />
            <Route path="site-labels" element={<PermissionGuard permission="content"><SiteLabels /></PermissionGuard>} />
            <Route path="highlighted-events" element={<PermissionGuard permission="highlighted_events"><HighlightedEvents /></PermissionGuard>} />
            <Route path="home-categories" element={<PermissionGuard permission="home_categories"><HomeCategories /></PermissionGuard>} />
            <Route path="home-category-order" element={<PermissionGuard permission="home_category_order"><HomeCategoryOrder /></PermissionGuard>} />
            <Route path="expedition" element={<PermissionGuard permission="expedition"><ExpeditionList /></PermissionGuard>} />
            <Route path="expedition-page" element={<PermissionGuard permission="expedition_page"><ExpeditionPage /></PermissionGuard>} />
            <Route path="categories" element={<PermissionGuard permission="categories"><Campsites /></PermissionGuard>} />
            <Route path="campsites" element={<PermissionGuard permission="categories"><Campsites /></PermissionGuard>} />
            <Route path="event-types" element={<PermissionGuard permission="categories"><EventTypes /></PermissionGuard>} />
            <Route path="locations" element={<PermissionGuard permission="categories"><Locations /></PermissionGuard>} />
            <Route path="treks" element={<PermissionGuard permission="treks"><Treks /></PermissionGuard>} />
            <Route path="whatsapp-automation" element={<PermissionGuard permission="whatsapp_automation"><WhatsAppAutomation /></PermissionGuard>} />
            <Route path="short-links" element={<PermissionGuard permission="short_links"><ShortLinks /></PermissionGuard>} />
            <Route path="attractions" element={<PermissionGuard permission="attractions"><Attractions /></PermissionGuard>} />
            <Route path="attractions/new" element={<PermissionGuard permission="attractions"><AttractionForm /></PermissionGuard>} />
            <Route path="attractions/:id" element={<PermissionGuard permission="attractions"><AttractionForm /></PermissionGuard>} />
            <Route path="add-ons" element={<PermissionGuard permission="add_ons"><AddOns /></PermissionGuard>} />
            <Route path="add-ons/new" element={<PermissionGuard permission="add_ons"><AddOnForm /></PermissionGuard>} />
            <Route path="add-ons/:id" element={<PermissionGuard permission="add_ons"><AddOnForm /></PermissionGuard>} />
            <Route path="store-products" element={<PermissionGuard permission="store_products"><StoreProducts /></PermissionGuard>} />
            <Route path="store-products/new" element={<PermissionGuard permission="store_products"><StoreProductForm /></PermissionGuard>} />
            <Route path="store-products/edit/:id" element={<PermissionGuard permission="store_products"><StoreProductForm /></PermissionGuard>} />
            <Route path="store-stock" element={<PermissionGuard permission="store_stock"><StoreStock /></PermissionGuard>} />
            <Route path="store-returns" element={<PermissionGuard permission="store_returns"><StoreReturns /></PermissionGuard>} />
            <Route path="store-merchandise-orders" element={<PermissionGuard permission="store_orders"><StoreMerchandiseOrders /></PermissionGuard>} />
            <Route path="store-camper-orders" element={<PermissionGuard permission="store_orders"><StoreCamperOrders /></PermissionGuard>} />
            <Route path="treks/:trekId/packages/:packageId" element={<PermissionGuard permission="treks"><TrekPackageForm /></PermissionGuard>} />
            <Route path="treks/:trekId/schedule/:scheduleId" element={<PermissionGuard permission="treks"><TrekScheduleForm /></PermissionGuard>} />
            <Route path="treks/:trekId/attractions/:attractionId" element={<PermissionGuard permission="treks"><TrekAttractionForm /></PermissionGuard>} />
            <Route path="treks/:trekId/fees-includes/:feeId" element={<PermissionGuard permission="treks"><TrekFeeIncludeForm /></PermissionGuard>} />
            <Route path="treks/:trekId/instructions/:instructionId" element={<PermissionGuard permission="treks"><TrekInstructionForm /></PermissionGuard>} />
            <Route path="event-batches" element={<PermissionGuard permission="event_batches"><EventBatches /></PermissionGuard>} />
            <Route path="event-batches/new" element={<PermissionGuard permission="event_batches"><EventBatchForm /></PermissionGuard>} />
            <Route path="event-batches/:batchId/edit" element={<PermissionGuard permission="event_batches"><EventBatchForm /></PermissionGuard>} />
            <Route path="registrations" element={<PermissionGuard permission="registrations"><Registrations /></PermissionGuard>} />
            <Route path="tickets" element={<PermissionGuard permission="tickets"><Tickets /></PermissionGuard>} />
            <Route path="receipts" element={<PermissionGuard permission="receipts"><Receipts /></PermissionGuard>} />
            <Route path="manual-receipts" element={<PermissionGuard permission="receipts"><ManualReceipts /></PermissionGuard>} />
            <Route
              path="manual-receipts/new"
              element={
                <PermissionGuard permission="receipts">
                  <ManualReceiptForm />
                </PermissionGuard>
              }
            />
            <Route path="cancellations" element={<PermissionGuard permission="cancellations"><Cancellations /></PermissionGuard>} />
            <Route
              path="refund-calculator"
              element={
                <PermissionGuard permission="cancellations_manage">
                  <RefundCalculatorCategories />
                </PermissionGuard>
              }
            />
            <Route path="special-events" element={<PermissionGuard permission="special_events"><SpecialEvents /></PermissionGuard>} />
            <Route path="special-events/new" element={<PermissionGuard permission="special_events"><SpecialEventForm /></PermissionGuard>} />
            <Route path="special-events/:id/edit" element={<PermissionGuard permission="special_events"><SpecialEventForm /></PermissionGuard>} />
            <Route path="contact" element={<PermissionGuard permission="contact"><ContactManagement /></PermissionGuard>} />
            <Route path="contact/offices/new" element={<PermissionGuard permission="contact"><OfficeForm /></PermissionGuard>} />
            <Route path="contact/offices/:id/edit" element={<PermissionGuard permission="contact"><OfficeForm /></PermissionGuard>} />
            <Route path="about" element={<PermissionGuard permission="about"><AboutManagement /></PermissionGuard>} />
            <Route path="team" element={<PermissionGuard permission="team"><TeamManagement /></PermissionGuard>} />
            <Route path="careers" element={<PermissionGuard permission="careers"><CareersManagement /></PermissionGuard>} />
            <Route path="applicants" element={<PermissionGuard permission="applicants"><Applicants /></PermissionGuard>} />
            <Route path="lead-requests" element={<PermissionGuard permission="lead_requests"><LeadRequests /></PermissionGuard>} />
            <Route path="lead-reports" element={<PermissionGuard permission="lead_reports"><LeadReports /></PermissionGuard>} />
            <Route path="support-tickets" element={<PermissionGuard permission="lead_requests"><SupportTickets /></PermissionGuard>} />
            <Route path="create-lead" element={<PermissionGuard permission="lead_requests_create"><CreateManualLead /></PermissionGuard>} />
            <Route path="callback-requests" element={<PermissionGuard permission="lead_requests"><CallbackRequests /></PermissionGuard>} />
            <Route path="volunteer-inquiries" element={<PermissionGuard permission="volunteer_inquiries"><VolunteerInquiries /></PermissionGuard>} />
            <Route path="pdf-requests" element={<PermissionGuard permission="lead_requests"><PdfRequests /></PermissionGuard>} />
            <Route path="training-camp" element={<PermissionGuard permission="registrations"><TrainingCamp /></PermissionGuard>} />
            <Route path="training-camp/submissions" element={<PermissionGuard permission="registrations"><TrainingCamp defaultTab="submissions" /></PermissionGuard>} />
            <Route path="training-camp/slots" element={<PermissionGuard permission="registrations"><TrainingCamp defaultTab="slots" /></PermissionGuard>} />
            <Route path="profile" element={<AdminProfile />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
